import {
  ODataHeader,
  ODataString,
  ODataDate,
  ODataCustom,
  ODataEnum,
  ODataStringContains,
  ODataStringEndsWith,
  ODataStringEquals,
  ODataStringNotContains,
  ODataStringNotEquals,
  ODataStringStartsWith,
  ODataDateTime,
  ODataBoolean
} from "pbas-vue-components";
import { translate2 } from "../trans2";
import { i18n } from "@/plugins/i18n";
import { translate } from "../trans";
import store from "@/store";

function formatDate(dateString) {
  if (dateString === undefined || dateString === null) {
    return "";
  }
  const [date, time] = dateString.split("T");
  const [year, month, day] = date.split("-");
  return `${year}-${month}-${day}`;
}
export default function getMembershipHistoryHeaders(
  options,
  planType,
  hasClasses
) {
  var h1 = [
    new ODataHeader({
      type: new ODataString("Id"),
      visible: false,
      isIdentifier: true,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      title: "components.inmemorydependants.effective_date",
      type: new ODataDate("EffectiveDate"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.membership_history.is_eligible",
      type: new ODataBoolean("IsEligible"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      type: new ODataString("ActivityStatus/Translations[]/LanguageCode"),
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    // new ODataHeader({
    //   type: new ODataString("ActivityStatus/Translations[]/Id"),
    //   sortable: false,
    //   visible: false,
    //   allowVisibilityChange: false,
    //   searchable: false,
    // }),
    // new ODataHeader({
    //   title: "headers.membership_history.activity_status",
    //   type: new ODataString("ActivityStatus/Translations[]/Name", {
    //     getString: (item) => translate2(item.ActivityStatus, "Name"),
    //   }),
    //   sortable: true,
    //   visible: true,
    //   searchable: true,
    //   orderByKey: "ActivityStatus/Name",
    //   allowVisibilityChange: true,
    // }),
    // new ODataHeader({
    //   type: new ODataString("ActivityStatus/Name"),
    //   visible: false,
    //   allowVisibilityChange: false,
    // }),
    // new ODataHeader({
    //   type: new ODataString("ActivityStatusId"),
    //   visible: false,
    //   allowVisibilityChange: false,
    //   searchable: false,
    // }),
    // new ODataHeader({
    //   title: "Billing Term Id",
    //   type: new ODataString("ActivityStatus/Id"),
    //   visible: false,
    //   allowVisibilityChange: false,
    //   searchable: false,
    // }),
    new ODataHeader({
      title: "globals.member_group",
      type: new ODataString("CurrentMemberGroup/Translations[]/Name", {
        getString: (item) => translate2(item.CurrentMemberGroup, "Name"),
      }),
      sortable: false,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new ODataHeader({
      type: new ODataString(
        "CurrentMemberGroup/Translations[]/LanguageCode"
      ),
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
  ]
  if (hasClasses) {
    h1.push(new ODataHeader({
      title: "globals.class",
      type: new ODataString("Class"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),)
  }
  // if (planType === "Pension") {
  //   return [
      
  //     new ODataHeader({
  //       title: "headers.membership_history.termination_date",
  //       type: new ODataDate("TerminationDate"),
  //       sortable: true,
  //       visible: true,
  //       searchable: true,
  //     }),
  //     new ODataHeader({
  //       title: "components.memberview.extension_termination_date",
  //       type: new ODataDate("ExtensionTerminationDate"),
  //       sortable: true,
  //       visible: true,
  //       searchable: true,
  //     }),
  //     new ODataHeader({
  //       title: "headers.membership_history.reinstated_date",
  //       type: new ODataDate("ReinstatedDate"),
  //       sortable: true,
  //       visible: true,
  //       searchable: true,
  //     }),
  //     new ODataHeader({
  //       type: new ODataString("ModelReason"),
  //       visible: false,
  //       allowVisibilityChange: false,
  //       searchable: false,
  //     }),
  //     new ODataHeader({
  //       title: "globals.reason",
  //       type: new ODataCustom("ModelValue", {
  //         getString: (item, type) => {
  //           if (item.ModelValue === null || item.ModelValue === undefined) {
  //             return "";
  //           }
  //           return i18n.t("enums." + item.ModelValue);
  //         },
  //         getWildcardFilter: (search) => {
  //           return `((contains(tolower(cast(ModelValue, 'Edm.String')), '${search}')))`;
  //         },
  //         getFilter: (callback) => {
  //           const res = callback("ModelValue");
  //           if (res.indexOf("not contains") > -1) {
  //             const search = res.split(",")[1].slice(0, -2).substring(2);
  //             return `((not contains(tolower(cast(ModelValue, 'Edm.String')), '${search}')))`;
  //           } else if (res.indexOf("contains") > -1) {
  //             const search = res.split(",")[1].slice(0, -2).substring(2);
  //             return `((contains(tolower(cast(ModelValue, 'Edm.String')), '${search}')))`;
  //           } /*else if (res.indexOf("eq") > -1) {
  //             const search = res
  //               .split("eq")[1]
  //               .slice(0, -1)
  //               .substring(2);
  //             return `((ModelValue eq '${search}'))`;
  //           } else if (res.indexOf("ne") > -1) {
  //             const search = res
  //               .split("ne")[1]
  //               .slice(0, -1)
  //               .substring(2);
  //             return `((ModelValue ne '${search}'))`;
  //           } */ else if (res.indexOf("startswith") > -1) {
  //             const search = res.split(",")[1].slice(0, -2).substring(2);
  //             return `((startswith(tolower(cast(ModelValue, 'Edm.String')), '${search}')))`;
  //           } else if (res.indexOf("endswith") > -1) {
  //             const search = res.split(",")[1].slice(0, -2).substring(2);
  //             return `((endswith(tolower(cast(ModelValue, 'Edm.String')), '${search}')))`;
  //           }
  //           return undefined;
  //         },
  //         operators: [
  //           new ODataStringContains(),
  //           new ODataStringNotContains(),
  //           // new ODataStringEquals(),
  //           // new ODataStringNotEquals(),
  //           new ODataStringStartsWith(),
  //           new ODataStringEndsWith(),
  //         ],
  //       }),
  //       sortable: true,
  //       visible: true,
  //       searchable: true,
  //     }),
  //     new ODataHeader({
  //       title: "globals.trigger",
  //       type: new ODataCustom("Role", {
  //         getString: (item, type) => {
  //           if (
  //             item.EligibilityRule !== null &&
  //             item.EligibilityRule !== undefined
  //           ) {
  //             return i18n.t("enums." + item.EligibilityRule.RuleType);
  //           }
  //           return `${item.Role} (${item.Email})`;
  //         },
  //         getWildcardFilter: (search) => {
  //           return `((contains(tolower(cast(EligibilityRule/RuleType, 'Edm.String')), '${search}'))) or ((contains(tolower(Role), '${search}'))) or ((contains(tolower(Email), '${search}')))`;
  //         },
  //         // getFilter: (callback) => {
  //         //   const res = callback("Email");
  //         //   if (res.indexOf("not contains") > -1) {
  //         //     const search = res
  //         //       .split(",")[1]
  //         //       .slice(0, -2)
  //         //       .substring(2);
  //         //     return `((not contains(tolower(cast(EligibilityRule/RuleType, 'Edm.String')), '${search}'))) and ((not contains(tolower(Role), '${search}'))) and ((not contains(tolower(Email), '${search}')))`;
  //         //   } else if (res.indexOf("contains") > -1) {
  //         //     const search = res
  //         //       .split(",")[1]
  //         //       .slice(0, -2)
  //         //       .substring(2);
  //         //     return `((contains(tolower(cast(EligibilityRule/RuleType, 'Edm.String')), '${search}'))) or ((contains(tolower(Role), '${search}'))) or ((contains(tolower(Email), '${search}')))`;
  //         //   } /*else if (res.indexOf("eq") > -1) {
  //         //     const search = res
  //         //       .split("eq")[1]
  //         //       .slice(0, -1)
  //         //       .substring(2);
  //         //     return `((EligibilityRule/RuleType eq '${search}')) or ((Role eq '${search}')) or ((Email eq '${search}'))`;
  //         //   } else if (res.indexOf("ne") > -1) {
  //         //     const search = res
  //         //       .split("ne")[1]
  //         //       .slice(0, -1)
  //         //       .substring(2);
  //         //       return `((EligibilityRule/RuleType ne '${search}')) and ((Role ne '${search}')) and ((Email ne '${search}'))`;
  //         //   } else if (res.indexOf("startswith") > -1) {
  //         //     const search = res
  //         //       .split(",")[1]
  //         //       .slice(0, -2)
  //         //       .substring(2);
  //         //     return `((startswith(tolower(cast(EligibilityRule/RuleType, 'Edm.String')), '${search}'))) or ((startswith(tolower(Role), '${search}'))) or ((startswith(tolower(Email), '${search}')))`;
  //         //   } else if (res.indexOf("endswith") > -1) {
  //         //     const search = res
  //         //       .split(",")[1]
  //         //       .slice(0, -2)
  //         //       .substring(2);
  //         //       return `((endswith(tolower(cast(EligibilityRule/RuleType, 'Edm.String')), '${search}'))) or ((endswith(tolower(Role), '${search}'))) or ((endswith(tolower(Email), '${search}')))`;
  //         //   }*/
  //         //   return undefined;
  //         // },
  //         // operators: [
  //         //   new ODataStringContains(),
  //         //   new ODataStringNotContains(),
  //         //   // new ODataStringEquals(),
  //         //   // new ODataStringNotEquals(),
  //         //   new ODataStringStartsWith(),
  //         //   new ODataStringEndsWith(),
  //         // ]
  //       }),
  //       sortable: true,
  //       visible: true,
  //       searchable: true,
  //       subHeaders: [
  //         new ODataHeader({
  //           title: "globals.trigger",
  //           type: new ODataCustom("Role", {
  //             getWildcardFilter: (search) => {
  //               return `((contains(tolower(cast(EligibilityRule/RuleType, 'Edm.String')), '${search}'))) or ((contains(tolower(Role), '${search}'))) or ((contains(tolower(Email), '${search}')))`;
  //             },
  //             getFilter: (callback) => {
  //               const res = callback("Email");
  //               if (res.indexOf("not contains") > -1) {
  //                 const search = res.split(",")[1].slice(0, -2).substring(2);
  //                 return `((not contains(tolower(cast(EligibilityRule/RuleType, 'Edm.String')), '${search}'))) and ((not contains(tolower(Role), '${search}'))) and ((not contains(tolower(Email), '${search}')))`;
  //               } else if (res.indexOf("contains") > -1) {
  //                 const search = res.split(",")[1].slice(0, -2).substring(2);
  //                 return `((contains(tolower(cast(EligibilityRule/RuleType, 'Edm.String')), '${search}'))) or ((contains(tolower(Role), '${search}'))) or ((contains(tolower(Email), '${search}')))`;
  //               } /*else if (res.indexOf("eq") > -1) {
  //                 const search = res
  //                   .split("eq")[1]
  //                   .slice(0, -1)
  //                   .substring(2);
  //                 return `((EligibilityRule/RuleType eq '${search}')) or ((Role eq '${search}')) or ((Email eq '${search}'))`;
  //               } else if (res.indexOf("ne") > -1) {
  //                 const search = res
  //                   .split("ne")[1]
  //                   .slice(0, -1)
  //                   .substring(2);
  //                   return `((EligibilityRule/RuleType ne '${search}')) and ((Role ne '${search}')) and ((Email ne '${search}'))`;
  //               } else if (res.indexOf("startswith") > -1) {
  //                 const search = res
  //                   .split(",")[1]
  //                   .slice(0, -2)
  //                   .substring(2);
  //                 return `((startswith(tolower(cast(EligibilityRule/RuleType, 'Edm.String')), '${search}'))) or ((startswith(tolower(Role), '${search}'))) or ((startswith(tolower(Email), '${search}')))`;
  //               } else if (res.indexOf("endswith") > -1) {
  //                 const search = res
  //                   .split(",")[1]
  //                   .slice(0, -2)
  //                   .substring(2);
  //                   return `((endswith(tolower(cast(EligibilityRule/RuleType, 'Edm.String')), '${search}'))) or ((endswith(tolower(Role), '${search}'))) or ((endswith(tolower(Email), '${search}')))`;
  //               }*/
  //               return undefined;
  //             },
  //             operators: [
  //               new ODataStringContains(),
  //               new ODataStringNotContains(),
  //               // new ODataStringEquals(),
  //               // new ODataStringNotEquals(),
  //               new ODataStringStartsWith(),
  //               new ODataStringEndsWith(),
  //             ],
  //           }),
  //           sortable: false,
  //           visible: true,
  //           searchable: true,
  //           subHeaders: [
  //             new ODataHeader({
  //               type: new ODataString("Email"),
  //               visible: false,
  //               allowVisibilityChange: false,
  //               searchable: false,
  //               sortable: true,
  //             }),
  //             new ODataHeader({
  //               type: new ODataString("EligibilityRule/RuleType"),
  //               visible: false,
  //               allowVisibilityChange: false,
  //               searchable: false,
  //               sortable: true,
  //             }),
  //           ],
  //         }),
  //         new ODataHeader({
  //           type: new ODataString("Email"),
  //           visible: false,
  //           allowVisibilityChange: false,
  //           searchable: false,
  //           sortable: true,
  //         }),
  //         new ODataHeader({
  //           type: new ODataString("EligibilityRule/RuleType"),
  //           visible: false,
  //           allowVisibilityChange: false,
  //           searchable: false,
  //           sortable: true,
  //         }),
  //       ],
  //     }),
  //     new ODataHeader({
  //       type: new ODataString("EligibilityRule/RuleType"),
  //       visible: false,
  //       allowVisibilityChange: false,
  //       searchable: false,
  //     }),
  //     new ODataHeader({
  //       type: new ODataString("Email"),
  //       visible: false,
  //       allowVisibilityChange: false,
  //       searchable: false,
  //     }),
  //     new ODataHeader({
  //       type: new ODataString("SourceOfInformation/Name"),
  //       sortable: false,
  //       visible: false,
  //       allowVisibilityChange: false,
  //       searchable: false,
  //     }),
  //     new ODataHeader({
  //       type: new ODataString(
  //         "SourceOfInformation/Translations[]/LanguageCode"
  //       ),
  //       sortable: false,
  //       visible: false,
  //       allowVisibilityChange: false,
  //       searchable: false,
  //     }),
  //     new ODataHeader({
  //       title: "globals.source_of_information",
  //       type: new ODataString(
  //         "SourceOfInformation/Translations[]/DisplayValue",
  //         {
  //           getString: (item) =>
  //             translate(
  //               item.SourceOfInformation,
  //               store.getters["common/language"].language
  //             ),
  //         }
  //       ),
  //       sortable: true,
  //       visible: true,
  //       searchable: true,
  //       orderByKey: "SourceOfInformation/Name",
  //       allowVisibilityChange: true,
  //     }),
  //     new ODataHeader({
  //       title: "globals.timestamp",
  //       type: new ODataDateTime("Timestamp"),
  //       sortable: true,
  //       visible: true,
  //       searchable: true,
  //       allowVisibilityChange: true,
  //     }),
  //   ];
  // } else {
    
    const h2 = [
      new ODataHeader({
        title: "headers.benefitrules.termination",
        type: new ODataDate("TerminationDate", {
          getString: (item) => {
            if (item.TerminationDate !== null && item.TerminationDate!== null) {
              var date = formatDate(item.TerminationDate);
              if (item.TerminationReason !== null && item.TerminationReason !== undefined) {
                return date + ` (${item.TerminationReason})`
              }
              return date;
            }
            return ""
          }
        }),
        sortable: true,
        visible: true,
        searchable: true,
      }),
      new ODataHeader({
        type: new ODataDate("TerminationReason"),
        sortable: false,
        visible: false,
        searchable: true,
        allowVisibilityChange: false
      }),
      new ODataHeader({
        title: "headers.membership_history.extension",
        type: new ODataDate("ExtensionTerminationDate"),
        sortable: true,
        visible: true,
        searchable: true,
      }),
      // new ODataHeader({
      //   title: "headers.membership_history.reinstated_date",
      //   type: new ODataDate("ReinstatedDate"),
      //   sortable: true,
      //   visible: true,
      //   searchable: true,
      // }),
      new ODataHeader({
        type: new ODataString("ModelReason"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
      }),
      new ODataHeader({
        title: "globals.reason",
        type: new ODataCustom("ModelValue", {
          getString: (item, type) => {
            if (item.ModelValue === null || item.ModelValue === undefined) {
              return "";
            }
            return i18n.t("enums." + item.ModelValue);
          },
          getWildcardFilter: (search) => {
            return `((contains(tolower(cast(ModelValue, 'Edm.String')), '${search}')))`;
          },
          getFilter: (callback) => {
            const res = callback("ModelValue");
            if (res.indexOf("not contains") > -1) {
              const search = res.split(",")[1].slice(0, -2).substring(2);
              return `((not contains(tolower(cast(ModelValue, 'Edm.String')), '${search}')))`;
            } else if (res.indexOf("contains") > -1) {
              const search = res.split(",")[1].slice(0, -2).substring(2);
              return `((contains(tolower(cast(ModelValue, 'Edm.String')), '${search}')))`;
            } /*else if (res.indexOf("eq") > -1) {
            const search = res
              .split("eq")[1]
              .slice(0, -1)
              .substring(2);
            return `((ModelValue eq '${search}'))`;
          } else if (res.indexOf("ne") > -1) {
            const search = res
              .split("ne")[1]
              .slice(0, -1)
              .substring(2);
            return `((ModelValue ne '${search}'))`;
          } */ else if (res.indexOf("startswith") > -1) {
              const search = res.split(",")[1].slice(0, -2).substring(2);
              return `((startswith(tolower(cast(ModelValue, 'Edm.String')), '${search}')))`;
            } else if (res.indexOf("endswith") > -1) {
              const search = res.split(",")[1].slice(0, -2).substring(2);
              return `((endswith(tolower(cast(ModelValue, 'Edm.String')), '${search}')))`;
            }
            return undefined;
          },
          operators: [
            new ODataStringContains(),
            new ODataStringNotContains(),
            // new ODataStringEquals(),
            // new ODataStringNotEquals(),
            new ODataStringStartsWith(),
            new ODataStringEndsWith(),
          ],
        }),
        sortable: true,
        visible: true,
        searchable: true,
      }),
      new ODataHeader({
        title: "globals.trigger",
        type: new ODataCustom("Role", {
          getString: (item, type) => {
            if (
              item.EligibilityRule !== null &&
              item.EligibilityRule !== undefined
            ) {
              return i18n.t("enums." + item.EligibilityRule.RuleType);
            }
            return `${item.Role} (${item.Email})`;
          },
          getWildcardFilter: (search) => {
            return `((contains(tolower(cast(EligibilityRule/RuleType, 'Edm.String')), '${search}'))) or ((contains(tolower(Role), '${search}'))) or ((contains(tolower(Email), '${search}')))`;
          },
          // getFilter: (callback) => {
          //   const res = callback("Email");
          //   if (res.indexOf("not contains") > -1) {
          //     const search = res
          //       .split(",")[1]
          //       .slice(0, -2)
          //       .substring(2);
          //     return `((not contains(tolower(cast(EligibilityRule/RuleType, 'Edm.String')), '${search}'))) and ((not contains(tolower(Role), '${search}'))) and ((not contains(tolower(Email), '${search}')))`;
          //   } else if (res.indexOf("contains") > -1) {
          //     const search = res
          //       .split(",")[1]
          //       .slice(0, -2)
          //       .substring(2);
          //     return `((contains(tolower(cast(EligibilityRule/RuleType, 'Edm.String')), '${search}'))) or ((contains(tolower(Role), '${search}'))) or ((contains(tolower(Email), '${search}')))`;
          //   } /*else if (res.indexOf("eq") > -1) {
          //     const search = res
          //       .split("eq")[1]
          //       .slice(0, -1)
          //       .substring(2);
          //     return `((EligibilityRule/RuleType eq '${search}')) or ((Role eq '${search}')) or ((Email eq '${search}'))`;
          //   } else if (res.indexOf("ne") > -1) {
          //     const search = res
          //       .split("ne")[1]
          //       .slice(0, -1)
          //       .substring(2);
          //       return `((EligibilityRule/RuleType ne '${search}')) and ((Role ne '${search}')) and ((Email ne '${search}'))`;
          //   } else if (res.indexOf("startswith") > -1) {
          //     const search = res
          //       .split(",")[1]
          //       .slice(0, -2)
          //       .substring(2);
          //     return `((startswith(tolower(cast(EligibilityRule/RuleType, 'Edm.String')), '${search}'))) or ((startswith(tolower(Role), '${search}'))) or ((startswith(tolower(Email), '${search}')))`;
          //   } else if (res.indexOf("endswith") > -1) {
          //     const search = res
          //       .split(",")[1]
          //       .slice(0, -2)
          //       .substring(2);
          //       return `((endswith(tolower(cast(EligibilityRule/RuleType, 'Edm.String')), '${search}'))) or ((endswith(tolower(Role), '${search}'))) or ((endswith(tolower(Email), '${search}')))`;
          //   }*/
          //   return undefined;
          // },
          // operators: [
          //   new ODataStringContains(),
          //   new ODataStringNotContains(),
          //   // new ODataStringEquals(),
          //   // new ODataStringNotEquals(),
          //   new ODataStringStartsWith(),
          //   new ODataStringEndsWith(),
          // ]
        }),
        sortable: true,
        visible: true,
        searchable: true,
        subHeaders: [
          new ODataHeader({
            title: "globals.trigger",
            type: new ODataCustom("Role", {
              getWildcardFilter: (search) => {
                return `((contains(tolower(cast(EligibilityRule/RuleType, 'Edm.String')), '${search}'))) or ((contains(tolower(Role), '${search}'))) or ((contains(tolower(Email), '${search}')))`;
              },
              getFilter: (callback) => {
                const res = callback("Email");
                if (res.indexOf("not contains") > -1) {
                  const search = res.split(",")[1].slice(0, -2).substring(2);
                  return `((not contains(tolower(cast(EligibilityRule/RuleType, 'Edm.String')), '${search}'))) and ((not contains(tolower(Role), '${search}'))) and ((not contains(tolower(Email), '${search}')))`;
                } else if (res.indexOf("contains") > -1) {
                  const search = res.split(",")[1].slice(0, -2).substring(2);
                  return `((contains(tolower(cast(EligibilityRule/RuleType, 'Edm.String')), '${search}'))) or ((contains(tolower(Role), '${search}'))) or ((contains(tolower(Email), '${search}')))`;
                } /*else if (res.indexOf("eq") > -1) {
                const search = res
                  .split("eq")[1]
                  .slice(0, -1)
                  .substring(2);
                return `((EligibilityRule/RuleType eq '${search}')) or ((Role eq '${search}')) or ((Email eq '${search}'))`;
              } else if (res.indexOf("ne") > -1) {
                const search = res
                  .split("ne")[1]
                  .slice(0, -1)
                  .substring(2);
                  return `((EligibilityRule/RuleType ne '${search}')) and ((Role ne '${search}')) and ((Email ne '${search}'))`;
              } else if (res.indexOf("startswith") > -1) {
                const search = res
                  .split(",")[1]
                  .slice(0, -2)
                  .substring(2);
                return `((startswith(tolower(cast(EligibilityRule/RuleType, 'Edm.String')), '${search}'))) or ((startswith(tolower(Role), '${search}'))) or ((startswith(tolower(Email), '${search}')))`;
              } else if (res.indexOf("endswith") > -1) {
                const search = res
                  .split(",")[1]
                  .slice(0, -2)
                  .substring(2);
                  return `((endswith(tolower(cast(EligibilityRule/RuleType, 'Edm.String')), '${search}'))) or ((endswith(tolower(Role), '${search}'))) or ((endswith(tolower(Email), '${search}')))`;
              }*/
                return undefined;
              },
              operators: [
                new ODataStringContains(),
                new ODataStringNotContains(),
                // new ODataStringEquals(),
                // new ODataStringNotEquals(),
                new ODataStringStartsWith(),
                new ODataStringEndsWith(),
              ],
            }),
            sortable: false,
            visible: true,
            searchable: true,
            subHeaders: [
              new ODataHeader({
                type: new ODataString("Email"),
                visible: false,
                allowVisibilityChange: false,
                searchable: false,
                sortable: true,
              }),
              new ODataHeader({
                type: new ODataString("EligibilityRule/RuleType"),
                visible: false,
                allowVisibilityChange: false,
                searchable: false,
                sortable: true,
              }),
            ],
          }),
          new ODataHeader({
            type: new ODataString("Email"),
            visible: false,
            allowVisibilityChange: false,
            searchable: false,
            sortable: true,
          }),
          new ODataHeader({
            type: new ODataString("EligibilityRule/RuleType"),
            visible: false,
            allowVisibilityChange: false,
            searchable: false,
            sortable: true,
          }),
        ],
      }),
      new ODataHeader({
        type: new ODataString("EligibilityRule/RuleType"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
      }),
      new ODataHeader({
        type: new ODataString("Email"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
      }),
      new ODataHeader({
        title: "globals.timestamp",
        type: new ODataDateTime("Timestamp"),
        sortable: true,
        visible: true,
        searchable: true,
        allowVisibilityChange: true,
      }),
    ];
    return h1.concat(h2);
  // }
}
